// extracted by mini-css-extract-plugin
export var active = "_e2-7";
export var blink = "_e2-8";
export var dropDownSelector = "_e2-4";
export var dropDownWrapper = "_e2-3";
export var fakeCursor = "_e2-6";
export var fontSizeButton = "_e2-9";
export var formQuillEditor = "_e2-0";
export var pressed = "_e2-a";
export var qlBlank = "_e2-1";
export var textFormattingToolbar = "_e2-2";
export var textToolbarOption = "_e2-5";